<div *ngIf="disableEditing"
    style="width: 100%; height: 100%; position: absolute; z-index: 100000; display: flex; justify-content: center; align-items: center;">
    <div class="spinner-border text-primary avatar-sm" role="status">
        <span class="visually-hidden">Loading...</span>
    </div>
</div>
<div class="modal-header bg-soft-info p-3">
    <h5 class="modal-title" id="exampleModalLabel" i18n="@@">{{model.name || "New Task"}}</h5>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="close-modal"
        (click)="close()"></button>
</div>

<div class="card-body p-4 ">

    <div class="tab-model" *ngFor="let strategy of model.strategies;">
        <div style=" margin-bottom: 1.25rem;">
            <ngb-accordion class="accordion" role="tablist" #acc="ngbAccordion" activeIds="static-1"
                aria-multiselectable="false">
                <ngb-panel id="static-1" class="accordion-item mb-1">
                    <ng-template ngbPanelTitle>
                        <a class="accordion-header" href="javascript:void(0);">

                            <div class="d-flex position-relative show" style="  z-index: 2;">
                                <h6 class="fs-14 mb-1">
                                    {{camelCaseToRegularText(strategy.name)}}
                                </h6>
                            </div>
                        </a>
                    </ng-template>

                    <ng-template ngbPanelContent>
                        <div style="margin-top: 1.25rem; margin-bottom: 1.25rem;">

                            <div class="row">
                                <div class="col-12 col-lg-6 mb-3" *ngFor="let data of strategy.customFields;"
                                    [ngStyle]="{'display': (data.isVisible) ? '': 'none' } ">
                                    <div>
                                        <span>
                                            <label *ngIf="data.caption != undefined else elseByType"
                                                for="job_type-field" class="form-label">{{data.caption}}</label>
                                            <ng-template #elseByType>
                                                <label for="job_type-field" class="form-label">
                                                    {{camelCaseToRegularText(strategy.$type)}}</label>
                                            </ng-template>

                                            <div *ngIf="data.dataType == enumDataType.Date else elseDropdown">
                                                <div class=" input-group d-flex form-control" style="padding: 0%;">
                                                    <input class=" flex-grow-1 form-control" #iValue="ngModel" required
                                                        style="border-width: 0;" [pattern]=datePattern
                                                        [disabled]="disableEditing" class="form-control" type="text"
                                                        [dropSpecialCharacters]="false" [(ngModel)]="data.value"
                                                        placeholder="DD/MM/YYYY" mask="00/00/0000"
                                                        i18n-placeholder="@@" />
                                                    <span class=" input-group-text ri-calendar-2-line "
                                                        style="border-width: 0; align-self: center;"
                                                        [disabled]="disableEditing" type="text" mwlFlatpickr [disableMobile]="true"
                                                        [(ngModel)]="data.value" [dateFormat]="'d/m/Y'"></span>
                                                </div>
                                            </div>
                                            <ng-template #elseDropdown>
                                                <div *ngIf="data.dataType == enumDataType.DropDown else elseBoolean">
                                                    <ng-select [items]="data.keyValues" [(ngModel)]="data.value"
                                                        appendTo="body" bindValue="value" [disabled]="disableEditing"  
                                                        [ngClass]="{ 'is-invalid px-form': (data.value==undefined) && (submitted == true) }"
                                                        class="cursorPointer dropdown form-control pt-0 pb-0 px-3 flex-grow-1"
                                                        [searchable]="false" [clearable]="false">

                                                        <ng-template ng-label-tmp let-item="item" let-clear="clear">
                                                            <span class="ng-value-label ">
                                                                {{item.key}}
                                                            </span>
                                                        </ng-template>

                                                        <ng-template ng-option-tmp class="border-light" let-item="item"
                                                            let-clear="clear">
                                                            <span class="ng-value-label">
                                                                {{item.key}}
                                                            </span>
                                                        </ng-template>
                                                    </ng-select>
                                                </div>
                                            </ng-template>

                                            <ng-template #elseBoolean>
                                                <div *ngIf="data.dataType == enumDataType.Boolean else elseBasicInput">
                                                    <div class="form-check form-switch">
                                                        <input [disabled]="disableEditing" class="form-check-input"
                                                            type="checkbox" [checked]="checkBoolValue(data.value)"
                                                            (change)="data.value = !data.value" />
                                                    </div>
                                                </div>
                                            </ng-template>

                                            <ng-template #elseBasicInput>
                                                <input [disabled]="disableEditing" class="form-control" type="text"
                                                    placeholder="Enter {{data.caption}}" i18n-placeholder="@@"
                                                    [(ngModel)]="data.value" />
                                            </ng-template>

                                            <div *ngIf="(data.value==undefined) && (submitted == true )"
                                                class='invalidInputTextMessage'>
                                                <div>
                                                    Input Required
                                                </div>
                                            </div>

                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </ngb-panel>
            </ngb-accordion>
        </div>
    </div>
    <div class="row ">
        <div class="gap-2" style="display: flex; justify-content: end;">
            <button *ngIf="model.id == undefined" [disabled]="disableEditing" type="button" class="btn btn-success"
                id="add-btn" (click)="onCreate()" i18n="@@">{{buttonName}}</button>
            <button *ngIf="model.id" [disabled]="disableEditing" type="button" class="btn btn-success" id="add-btn"
                (click)="onUpdate()" i18n="@@">{{buttonName}}</button>
        </div>
    </div>
</div>